import GlassCard from '../ui/GlassCard';

const TONES = {
  positive: {
    accent: 'from-emerald-400/30 via-emerald-300/10 to-transparent',
    chip: 'border-emerald-300/30 bg-emerald-300/[0.08] text-emerald-200',
    value: 'text-white',
  },
  alert: {
    accent: 'from-rose-400/30 via-rose-300/10 to-transparent',
    chip: 'border-rose-300/30 bg-rose-300/[0.08] text-rose-200',
    value: 'text-white',
  },
  neutral: {
    accent: 'from-violet-400/25 via-violet-300/10 to-transparent',
    chip: 'border-white/15 bg-white/[0.04] text-white/70',
    value: 'text-white',
  },
};

const DEFAULT_TONE = 'neutral';

function IndicatorCard({ title, value, subtitle, badge, hint, icon: Icon, tone = DEFAULT_TONE }) {
  const styles = TONES[tone] ?? TONES[DEFAULT_TONE];
  return (
    <GlassCard className="relative overflow-hidden p-5 sm:p-6">
      <div
        aria-hidden="true"
        className={`absolute -right-12 -top-12 h-40 w-40 rounded-full bg-gradient-to-br ${styles.accent} blur-2xl`}
      />
      <div className="relative flex items-start justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] text-white/70">
            <Icon />
          </span>
          <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-white/55">
            {title}
          </span>
        </div>
        {badge && (
          <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-mono uppercase tracking-[0.14em] ${styles.chip}`}>
            {badge}
          </span>
        )}
      </div>
      <p className={`relative mt-5 font-mono text-3xl tracking-tight sm:text-[2rem] ${styles.value}`}>
        {value}
      </p>
      {subtitle && (
        <p className="relative mt-2 text-sm text-white/65">{subtitle}</p>
      )}
      {hint && (
        <p className="relative mt-1 text-[11px] font-mono uppercase tracking-[0.18em] text-white/35">
          {hint}
        </p>
      )}
    </GlassCard>
  );
}

export default IndicatorCard;